import React, { Component } from 'react';
import { connect } from 'react-redux';
//import ReactDom from 'react-dom';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';
//import NewWindow from 'react-new-window'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';

import unreadActions from '../actions/unread_message_actions';
import userActions from '../actions/user_actions';
import windowActions from '../actions/window_actions';
import { flashApp } from '../utils/flashNotification';

import '../../src/index.css';

// Desktop notifications live in App plus src/utils/desktopNotifications.js.
// A half-built second copy used to sit in this file and was never rendered.

//allow react dev tools work
window.React = React;

export class MemberListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hovered: false,
            hub: {},
            chatBoxOpen: false,
            features: {
                width: 450,
                height: 450,
                left: 450,
                top: 450
            },
            //showWindowPortal: false,
            showFullProfile: false,
            unreadMessages: {},
        };
    }

    // Everything started here is held on the instance and stopped in
    // componentWillUnmount. None of it used to be, and MemberList keeps its
    // online and offline members in two separate lists, so every time someone
    // changed inOffice their row unmounted and remounted - leaving behind
    // another repaint interval and another NewMessage handler on the shared
    // connection each time, all still firing into the dead row.
    //
    // There was also a document contextmenu listener here that cancelled
    // the browser's right-click menu for the whole main window, added once
    // per member. Only this row's own right-click means something (it opens
    // the profile), so showProfile cancels the menu for that click instead.
    componentDidMount() {
        this.subscribeToHub();
        this.repaintTimer = setInterval(function () {
            //this.props.setWindowAutoClose(false);
            this.forceUpdate();
            //this.props.setWindowAutoClose(true);
        }.bind(this), 3000);
    }

    componentDidUpdate() {
        this.subscribeToHub();
    }

    componentWillUnmount() {
        clearInterval(this.repaintTimer);
        clearTimeout(this.messageRepaintTimer);
        this.unsubscribeFromHub();
    }

    // state.hub is {} until App's connection.start() resolves, so this runs
    // again from componentDidUpdate until the real connection arrives. It
    // used to bind on a one-shot 5s timer, which missed any connection slower
    // than that for the whole session. The handler and the connection it went
    // on are kept so componentWillUnmount takes exactly this one off again -
    // the connection belongs to App and outlives every row.
    subscribeToHub = () => {
        if (!this.hubBound && localStorage.getItem("token") !== null && this.props.hub && typeof this.props.hub.on === 'function') {
            this.hubBound = true;
            this.boundHub = this.props.hub;
            this.boundHub.on('NewMessage', this.onNewMessage);
        }
    };

    unsubscribeFromHub = () => {
        if (this.boundHub && typeof this.boundHub.off === 'function') {
            this.boundHub.off('NewMessage', this.onNewMessage);
        }
        this.boundHub = null;
    };

    // Repaints a second later so the unread marker the reducer sets for this
    // member is on screen without waiting for the 3s interval.
    onNewMessage = (message) => {
        if (!message || !message.payload || message.payload.userId !== this.props.member.id) {
            return;
        }
        clearTimeout(this.messageRepaintTimer);
        this.messageRepaintTimer = setTimeout(function () {
            this.forceUpdate();
        }.bind(this), 1000);
    };

    onMouseEnter = (e) => {
        this.setState({ hovered: true });
    };

    onMouseLeave = (e) => {
        this.setState({ hovered: false });
    };

    //showChatBox = () => {
    //  this.setState({ showWindowPortal: !this.state.showWindowPortal });
    //};

    openChatBox = () => {
        this.disableUnread();
        if (this.state.chatBoxOpen) {
            this.setState({ chatBoxOpen: false }, () => this.setState({ chatBoxOpen: true }));
        } else {
            this.setState({ chatBoxOpen: true });
        }
    };

    closeChatBox = () => {
        this.setState({ chatBoxOpen: false });
    };

    handleTabsDoubleClick = () => {
        this.disableUnread();
        this.props.callbackFromParent(this.props.member, true, true, false);
    };

    //closeWindowPortal = () => {
    //  this.setState({ showWindowPortal: false });
    //};

    showProfile = (event) => {
        // The right-click opens the profile, so the browser's own menu would
        // only cover it.
        if (event && typeof event.preventDefault === 'function') {
            event.preventDefault();
        }
        this.setState({ showFullProfile: true });
    };

    handleCloseFullProfile = () => {
        this.setState({ showFullProfile: false });
    };

    disableUnread = () => {
        this.props.updateRead(this.props.member.id);
        if (this.props.profile.hasOwnProperty('id')) { // current signed in user
            // Moves the read watermark, as ChatBoxTabsWindow.disableUnread
            // does. This had been commented out since rev 40 with no reason
            // given, so a conversation read by double-click cleared
            // UnreadMessageUser but left LastSeen behind - and MemberList
            // seeds the unread set from api/user/GetUnreadMessages, which
            // counts everything newer than LastSeen, so it came back unread
            // after a reload. false: this is a read, not a logout, so it must
            // not stamp validLogout.
            this.props.updateLastSeen(false);
            // The member is excluded explicitly rather than trusted to have been
            // cleared by the updateRead above. React batches updates inside an
            // event handler, so connect has not re-rendered and
            // this.props.unreadMessages is still the pre-dispatch object with
            // the member set. SaveUnreadMessages replaces the caller's whole
            // set, so posting it back re-persisted the conversation that was
            // just read; nothing clears the table at logout, so it came back as
            // a phantom notification at the next login.
            var memberId = this.props.member.id;
            var l = [];
            for (var property in this.props.unreadMessages) {

                if (property.includes("Object")) {
                    continue;
                }
                if (property === memberId) {
                    continue;
                }
                if (this.props.unreadMessages[property]) {
                    l.push(property);
                }
            }
            this.props.setUnreadIds(l);
        } else {
        }
        // Was commented out over "breaks window focus when double clicking",
        // which belonged to the old <a>-click trigger: that was a top-level
        // navigation and the browser moved focus with it. The trigger is a
        // hidden iframe now (utils/flashNotification.js), so nothing here
        // touches focus. Without this, double-clicking a name cleared the
        // unread marker but left the taskbar flashing until the tab itself
        // was clicked - the user had "selected the message" and it kept going.
        flashApp(this.props.preferences, 'flashstop');
        this.props.setIconFlash(false);
        //setTimeout(function () {
        //  this.forceUpdate();
        //}.bind(this), 1000);
    };

    render() {
        const { hovered } = this.state;
        const { chatBoxOpen } = this.state;
        const style = hovered ? { backgroundColor: "#ebebeb" } : {};

        const memberStatus = this.props.member.status;
        const memberInOffice = this.props.member.inOffice;
        const awayMessage = this.props.member.awayMessage;
        const awayTime = this.props.member.awayTime;
        //const onCall = this.props.member.onCall;

        let statusIcon;
        let memberName;
        let memberExtension;
        let awayMessageShow;
        let fullProfile;
        let lastName;
        let unreadIcon;

        //if (memberStatus === "inAvailable") {
        //  memberStatusIcon = <i className="material-icons" fontSize="small">check_circle</i>;
        //} else if (memberStatus === "inBusy") {
        //  memberStatusIcon = <i className="material-icons" fontSize="small">access_time</i>;
        //} else if (memberStatus === "outBusy") {
        //  memberStatusIcon = <i className="material-icons" fontSize="small">remove_circle_outline</i>;
        //} else if (memberStatus === "outDone") {
        //  memberStatusIcon = <i className="material-icons" fontSize="small">highlight_off</i>;
        //}

        // If member is in office and available.
        //if (memberStatus === "inAvailable") {
        if (memberInOffice === true && memberStatus === "Available") {
            memberName = <b style={{ color: '#0051d3', 'cursor': 'default' }}>{this.props.member.username}</b>;
            memberExtension = <b style={{ color: '#0051d3', 'cursor': 'default' }}>{this.props.member.extension}</b>;
        }

        // If member is in office and busy or is done for the day or they have disconnected.
        else if ((memberInOffice === true && memberStatus === "Busy") || (memberInOffice === false && memberStatus === "Done") || (memberInOffice === false && memberStatus === "Disconnected")) {
            memberName = this.props.member.username;
            memberExtension = this.props.member.extension;
        }

        // If member is out of office and will be back.
        else if (memberInOffice === false && memberStatus === "Busy") {
            memberName = <b>{this.props.member.username}</b>; ////////////////////////////////////////////////////
            memberExtension = <b>{this.props.member.extension}</b>;
        }

        // Any pair the chain above does not name. A presence sweep and its
        // undo once produced inOffice=false with status "Available" (see
        // NotificationsHub.SendUserActivePing), and a row whose name cell is
        // empty reads as the person having vanished. Paint a plain name.
        else {
            memberName = this.props.member.username;
            memberExtension = this.props.member.extension;
        }

        // If member is busy and has entered an away message, show clock icon and their away message.
        if (awayMessage !== null && awayMessage !== "") {
            statusIcon =
                <Tooltip
                    placement="top-end"
                    title={
                        <React.Fragment>
                            <h6>
                                Away Message
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" fontSize="small" style={{ transform: 'scale(1.2)', fontSize: '14px', marginTop: '2px', color: 'black', 'cursor': 'default', paddingRight: '48px' }}>
                        access_time
          </i>
                </Tooltip>;
            awayMessageShow = <div><br /><b>Away Message: </b><br />{awayMessage} - back by {awayTime}</div>;
        }

        // TODO: warning icon displays next to disconnected person
        // If member is disconnected, their away message gets reset if they had one and show warning icon.
        if (memberInOffice === false && memberStatus === "Disconnected") {
            statusIcon =
                <Tooltip
                    placement="top-end"
                    title={
                        <React.Fragment>
                            <h6>
                                Disconnected
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" fontSize="small" style={{ transform: 'scale(1.2)', fontSize: '14px', paddingTop: '2px', color: 'black', 'cursor': 'default', paddingRight: '48px' }}>
                        warning
          </i>
                </Tooltip >;
        }

        // If there is an unread message
        if (this.props.unreadMessages[this.props.member.id]) {
            //unreadIcon = <b style={{ transform: 'scale(1.2)', fontSize: '14px', paddingTop: '3px', color: '#d80000' }}><img src={marketMapsLogo} alt="logo" /></b>;
            unreadIcon = <b style={{ color: '#0051d3', 'cursor': 'default' }}><i style={{ transform: 'scale(1.2)', fontSize: '14px', marginTop: '3px', marginLeft: '5px', 'cursor': 'default' }} className="material-icons" fontSize="small">chat</i></b>;
            /*memberName = <b style={{ color: '#0051d3' }}>{this.props.member.firstName}</b>;
            memberExtension = <b style={{ color: '#0051d3' }}>{this.props.member.extension}</b>;*/

        } else {
            unreadIcon = <div></div>;
        }

        if (this.props.member.lastName === null) {
            lastName = "";
        }

        if (this.state.showFullProfile === true) {
            fullProfile =
                <Dialog
                    open={this.state.showFullProfile}
                    onClose={this.handleCloseFullProfile}
                    aria-labelledby="alert-dialog-title"
                    PaperProps={{ style: { minWidth: '195px' } }}
                >
                    <Typography id="alert-dialog-title" style={{ padding: '10px', fontWeight: '600', fontSize: '18px' }}>{this.props.member.username}'s Profile</Typography>
                    <DialogContent style={{ paddingTop: '0px', paddingRight: '5px', paddingBottom: '0px', paddingLeft: '5px', fontSize: '11px' }}>
                        <b>Name: </b>{this.props.member.firstName} {this.props.member.lastName ? this.props.member.lastName : ""}<br />
                        <b>Address: </b>{this.props.member.address}, {this.props.member.city}, {this.props.member.state}, {this.props.member.zipCode}<br />
                        <b>Work: </b>{this.props.member.workPhone}<br />
                        <b>Cell: </b>{this.props.member.cellPhone}<br />
                        <b>Home: </b>{this.props.member.homePhone}<br />
                        <b>Email: </b>{this.props.member.email}<br /><br />
                        <b>Monday: </b>{this.props.member.monday}<br />
                        <b>Tuesday: </b>{this.props.member.tuesday}<br />
                        <b>Wednesday: </b>{this.props.member.wednesday}<br />
                        <b>Thursday: </b>{this.props.member.thursday}<br />
                        <b>Friday: </b>{this.props.member.friday}<br />
                        <b>Saturday: </b>{this.props.member.saturday}<br />
                        <b>Sunday: </b>{this.props.member.sunday}<br />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseFullProfile} color="primary">
                            Close
            </Button>
                    </DialogActions>
                </Dialog>;
        }

        return (
            <div>
                <Tooltip
                    enterDelay={500}
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h4>
                                <b style={{ color: '#ffffff' }}>
                                    {this.props.member.firstName + " "}{this.props.member.lastName ? this.props.member.lastName : ""}
                                </b>
                            </h4>
                            <h6>
                                <b>Work: </b>{this.props.member.workPhone}<br />
                                <b>Cell: </b>{this.props.member.cellPhone}<br />
                                <b>Home: </b>{this.props.member.homePhone}<br />
                                {awayMessageShow}
                            </h6>
                        </React.Fragment>
                    }
                >
                    <div style={{ flexgrow: '1', margin: '0px' }} onDoubleClick={this.handleTabsDoubleClick} onContextMenu={this.showProfile}>
                        <Grid container spacing={0} style={style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                            <Grid style={{ 'cursor': 'default' }} item xs={1}>{unreadIcon}</Grid>
                            <Grid style={{ 'cursor': 'default', paddingLeft: '8px' }} item xs={7}>{memberName}</Grid>
                            <Grid style={{ 'cursor': 'default' }} item xs={3}>{memberExtension}</Grid>
                            <Grid style={{ 'cursor': 'default' }} item xs={1}>{statusIcon}</Grid>
                        </Grid>
                    </div>
                </Tooltip>
                {fullProfile}

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        hub: state.hub,
        unreadMessages: state.unreadMessages,
        profile: state.profile,
        preferences: state.preferences,
    };
}

const mapDispatchToProps = dispatch => ({
    updateRead: (userId) => dispatch(userActions['READ_MESSAGE'](userId)),
    setWindowAutoClose: shouldAutoClose => dispatch(windowActions['ALLOW_WINDOW_AUTO_CLOSE'](shouldAutoClose)),
    setUnreadIds: unreadIds => dispatch(unreadActions['SET_UNREAD_IDS'](unreadIds)),
    setIconFlash: shouldTurnFlashOn => dispatch(windowActions['SET_ICON_FLASH'](shouldTurnFlashOn)),
    updateLastSeen: (updateStamp) => dispatch(userActions['UPDATE_LAST_SEEN'](updateStamp)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MemberListItem);


// WEBPACK FOOTER //
// ./src/components/MemberListItem.js